export default "/images/bl-img-3.jpg?173a4ec6c9399dff5b190ca404663b8a";